// extracted by mini-css-extract-plugin
module.exports = {"block":"Footer_block__vsCG3","hr":"Footer_hr__2F7B3","links":"Footer_links__R0640","link":"Footer_link__3_PMk","row":"Footer_row__1E86m"};